export enum TrainingBrand {
  LOREAL_PROFESSIONNEL = 'loreal-professionnel',
  KERASTASE = 'kerastase',
  REDKEN = 'redken',
}
